import { useSearchParams } from "next/navigation";

export const useBrandPDPQueryParams = (
  fulfillment: "pickup" | "delivery" | "shipping",
  variant?: number | null,
  amount?: string | null,
) => {
  const searchParams = useSearchParams();
  const params = new URLSearchParams();

  const fulfillmentParam = searchParams?.get("fulfillment[]") || fulfillment;
  const amountParam = searchParams?.get("filter[amount]") || amount;

  const brandPdpFulfillmentParam = fulfillmentParam ? fulfillmentParam : null;
  const brandPdpAmountParam = amountParam ? amountParam : null;

  if (variant) {
    params.set("variantId", variant.toString());
  }
  if (brandPdpFulfillmentParam) {
    params.set("filter[fulfillment]", brandPdpFulfillmentParam);
  }
  if (brandPdpAmountParam) {
    params.set("filter[amount]", brandPdpAmountParam);
  }
  return params.toString();
};
